<ng-template #template let-modal>
    <div class="modal-body">
        <div class="d-flex align-items-center justify-content-between mb-4">
            <h3 class="modal-title mt-0 mb-0" id="modal-basic-title">{{ 'heading-title.user-profile' | translate }}</h3>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            </button>
        </div>
        <form [formGroup]="profileUpdate">
            <div class="row">
                <div class="col-lg-4 mb-4 mb-lg-0">
                    <div class="card h-100">
                        <div class="card-body">
                            <div class="profile-pic">
                                <div class="profile-bg">
                                    <span class="camera">
                                        <i class="fa-solid fa-camera"></i>
                                    </span>
                                    {{profile_image}}
                                    <!-- <img [src]="profile_image ? profile_image : _helper.DEFAULT_IMAGE.USER_PROFILE"
                                        alt="user_profile"
                                        (error)="$any($event.target).src = _helper.DEFAULT_IMAGE.USER_PROFILE"
                                        class="user-profile" >

                                        <input id="file" type="file" hidden (change)="onSelectImageFile($event)"
                                                #profile /> -->
                                </div>
                                <p class="username mt-3 mb-1">{{userDetails.username}}</p>
                                <p class="phone">+{{userDetails.phoneCode}} {{userDetails.phone}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="card h-100">
                        <div class="card-body">
                            <h3 class="profile-h3">{{'heading-title.general-information' | translate}}</h3>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group mb-3">
                                        <label for="">{{'label-title.username' | translate}}</label>
                                        <input type="text" class="form-control" formControlName="username"
                                            placeholder="{{'label-title.enter-username' | translate}}" name="" id="">
                                        <div class="required position-relative" *ngIf="profileUpdate.get('username')?.errors?.required && profileUpdate.get('username')?.touched">
                                            {{'validation-title.username-is-required' | translate}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group mb-0">
                                        <label for="">{{'label-title.subscription' | translate}}</label>
                                        <div class="position-relative">
                                            <div class="bubble"
                                                [ngClass]="userDetails.isSubscribed ? 'active' : 'inactive' ">
                                                <span class="bubble-outer-dot">
                                                    <span class="bubble-inner-dot"></span>
                                                </span>
                                            </div>
                                            <p class="profile_p ps-3"
                                                [ngClass]="userDetails.isSubscribed ? 'text-success' : 'text-danger'">
                                                {{userDetails.isSubscribed ? ('heading-title.active' | translate) : ('heading-title.unactive' | translate)}} </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-4">
                    <div class="card">
                        <div class="card-body">
                            <h3 class="profile-h3">{{'heading-title.contact-details' | translate}}</h3>
                            <div class="row">
                                <div class="col-md-6 col-lg-4">
                                    <div class="form-group mb-3">
                                        <label for="">{{'label-title.phone' | translate}}</label>
                                        <input type="text" placeholder="{{'label-title.enter-phone' | translate}}" formControlName="phone" [maxlength]="userSettings.maxPhoneLength" (keypress)="_helper.phone_number_validation($event)" class="form-control">
                                        <div class="required position-relative" *ngIf="profileUpdate.get('phone')?.errors?.required && profileUpdate.get('phone')?.touched">
                                            * {{'validation-title.phone-is-required' | translate}}
                                        </div>
                                        <div class="required position-relative" *ngIf="profileUpdate.get('phone')?.errors?.minlength">
                                            * {{'validation-title.min-phone-length-is' | translate}} {{userSettings.minPhoneLength}}
                                        </div>
                                        <div class="required position-relative" *ngIf="profileUpdate.get('phone')?.errors?.maxlength">
                                            * {{'validation-title.max-phone-length-is' | translate}} {{userSettings.maxPhoneLength}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-4">
                                    <div class="form-group mb-3">
                                        <label for="">{{'label-title.email' | translate}}</label>
                                        <input type="text" class="form-control" placeholder="{{'label-title.enter-email' | translate}}"
                                            formControlName="email">
                                        <div class="required position-relative" *ngIf="profileUpdate.get('email')?.errors?.required && profileUpdate.get('email')?.touched">* {{'validation-title.email-is-required' | translate}}</div>
                                        <div class="required position-relative" *ngIf="profileUpdate.get('email')?.errors?.pattern">* {{'validation-title.email-is-invalid' | translate}}</div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-4">
                                    <div class="form-group mb-3">
                                        <label for="">{{'label-title.password' | translate}}</label>
                                        <input type="text" class="form-control" placeholder="{{'label-title.enter-password' | translate}}"
                                            formControlName="password">
                                        <div class="required position-relative" *ngIf="profileUpdate.get('password')?.errors?.minlength && profileUpdate.get('password')?.touched">
                                                * {{'validation-title.password-must-be-more-then-6-letters' | translate}}
                                            </div>
                                    </div>
                                </div>
                                <div>
                                    <button class="btn_1" (click)="updateProfile()">{{'button-title.update' | translate}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-template>
